import * as swcHelpers from '@swc/helpers';
import { Types } from '@grandvisionhq/graphql';
import { getAttribute } from '../../../utils/get-line-item-attribute.js';
import { getLineItemImageUrl } from '../../../utils/get-line-item-image-url.js';
import { getLocalizedAttribute } from '../../../utils/get-line-item-localized-attribute.js';
import { getLineItemName } from '../../../utils/get-line-item-name.js';
import { getProductUrl } from '../../../utils/get-line-item-product-url.js';
import { getLocalizedString } from '../../../utils/get-localized-string.js';
import { getSharedProps } from '../../../utils/shared-line-item-data-mapper.js';
import { getContactLensSpecifications } from './utils/contact-lenses-subscription/get-contact-lens-specifications.js';
import { getLegacyProductByType } from './utils/contact-lenses-subscription/get-legacy-product-by-type.js';
import { getSolutionProperties } from './utils/contact-lenses-subscription/get-solution-properties.js';
import { getSubscriptionFrequencyLabel } from './utils/contact-lenses-subscription/get-subscription-frequency-labels.js';
import { getSubscriptionType } from './utils/contact-lenses-subscription/get-subscription-type.js';

const mapContactLensesSubscription = (lineItemRaw, settings, intl)=>{
    const solutionsProduct = getLegacyProductByType(lineItemRaw.bundleLineItems, Types.BundleLineItemProductType.SOLUTION);
    const mainBundleProduct = getLegacyProductByType(lineItemRaw.bundleLineItems, Types.BundleLineItemProductType.LENS);
    if (!mainBundleProduct) {
        console.error('This ContactLensesSubscriptionLineItem does not have a mainBundleLineItem');
        return null;
    }
    const mainBundleProductVariant = mainBundleProduct.masterData.current.variant;
    const shared = getSharedProps(lineItemRaw, mainBundleProduct, intl);
    const slug = getLocalizedString(intl.locale, mainBundleProduct.masterData.current.slug);
    const typeDetails = lineItemRaw.typeDetails;
    const { leftLens , rightLens  } = typeDetails.prescriptionForSubscription;
    const solutionProperties = solutionsProduct ? getSolutionProperties(solutionsProduct, intl) : null;
    const billingFrequency = getSubscriptionFrequencyLabel(typeDetails.billingFrequency, 'billingFrequency');
    const deliveryFrequency = getSubscriptionFrequencyLabel(typeDetails.deliveryFrequency, 'deliveryFrequency');
    const mapLensProductDetails = (lensProduct)=>{
        if (lensProduct === null) {
            return undefined;
        }
        return {
            name: getLineItemName(mainBundleProduct, intl.locale),
            specs: getContactLensSpecifications(lensProduct)
        };
    };
    return swcHelpers.objectSpread({}, shared, {
        type: 'contact-lenses-subscription',
        sku: lineItemRaw.sku,
        imageSku: getAttribute(mainBundleProductVariant, 'imageSku'),
        productSlug: slug,
        productId: mainBundleProduct.id,
        productUrl: getProductUrl(settings.productLinkFormatter, lineItemRaw, slug, intl.locale),
        brand: {
            name: getAttribute(mainBundleProductVariant, 'brand'),
            model: getAttribute(mainBundleProductVariant, 'brandModel'),
            modelCode: getAttribute(mainBundleProductVariant, 'brandModelCode')
        },
        imageUrl: getLineItemImageUrl(mainBundleProductVariant),
        erpId: getAttribute(mainBundleProductVariant, 'erpId'),
        lensType: getLocalizedAttribute(mainBundleProductVariant, 'lensType', intl.locale) || '',
        leftEyeProduct: mapLensProductDetails(leftLens),
        rightEyeProduct: mapLensProductDetails(rightLens),
        billingFrequency: intl.getLabel(billingFrequency),
        deliveryFrequency: intl.getLabel(deliveryFrequency),
        packageQuantity: getAttribute(mainBundleProductVariant, 'packageQuantity'),
        subscriptionType: getSubscriptionType(typeDetails)
    }, solutionProperties);
};

export { mapContactLensesSubscription };
//# sourceMappingURL=contact-lenses-subscription.js.map
